import React, { useState, useEffect, useContext  } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../Components/Navbar';
import Subscribe from '../Components/SubscribeSection';
import FixedImageMessage from '../Components/FixedImageMessage';
import Footer from '../Components/Footer';
import { AuthContext } from '../Components/AuthContext';
import LoginModal from '../Components/LoginModal';

const SampleProducts = () => {
  const location = useLocation();
  const productId = location.state?.productId; // Get the productId from the state
  const banner = location.state?.banner; // Use a default if no banner is passed
  const categoryName = location.state?.name;
  const description = location.state?.description;
  const image = location.state?.image;
  const { token } = useContext(AuthContext);
  const [product, setProduct] = useState(null); // State to store product data
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [error, setError] = useState(''); // State to store error messages
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleLoginSuccess = () => {
    window.location.reload(); // Reload the entire page on login success
  };

  // Fetch product details from the API
  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await axios.get(
          `https://backend.printtrio.co.uk/api/free-sample/single-page/${productId}`,
          {
            headers: {
              Accept: 'application/json',
            },
          }
        );
        
        if (response.data.success) {
          setProduct(response.data.data); // Store the product data
        } else {
          setError('Failed to fetch product details.');
        }
      } catch (err) {
        setError('An error occurred while fetching product details.');
      } finally {
        setLoading(false); // Set loading to false after the fetch completes
      }
    };

    if (productId) {
      fetchProductDetails(); // Fetch product details only if productId is available
    }
  }, [productId]); // Dependency array ensures this runs when productId changes

  const handleAddToCart = async () => {

    if (!token) {
        setIsModalVisible(true);  // Show login modal if not authenticated
        return;
      }

    try {
      const response = await axios.post(
        'https://backend.printtrio.co.uk/api/cart/add-to-cart-free-sample',
        { free_sample_id: productId }, // The free_sample_id to be passed in the request body
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`, // Pass the token in the headers
          },
        }
      );
  
      if (response.data.success) {
        setIsPopupVisible(true); // Show the popup on success
      } else {
        console.log('Failed to add the sample to the cart.');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      console.log('An error occurred while adding the product to the cart.');
    }
  };
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <p></p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div className="w-full bg-white">
  <div className="max-w-screen-xl mx-auto relative ">
      <div className="px-6 flex flex-col md:flex-row justify-between items-center"
        style={{
          backgroundImage: `url(${banner})`,
          backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        aspectRatio: '16 / 6',
        }}
      >
        <div className="flex-1  mr-44 md:mr-0 mt-10">
        <h1 className="text-white font-semibold mt-0 md-mt-0 text-xl md:text-4xl xl:text-6xl leading-tight mb-4 lg:px-16">
            {categoryName}
          </h1>
          <p className="text-white text-xs md:text-base mb-2 md:mb-8 xl:mb-20 lg:px-16 max-w-xl">
            {description}
          </p>
        </div>
      </div>
      </div>
      </div>
      <div className="flex flex-col items-center justify-center mb-10 bg-gray-100 py-12 px-4 sm:px-6 md:px-16 xl:px-48">

        {/* Card Container */}
        {product ? (
          <div className="bg-white rounded-lg shadow-lg overflow-hidden max-w-lg w-full ">
            {/* Product Image */}
            <img
              src={image}
              alt={product.name}
              className="w-full"
              style={{
              
                backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              aspectRatio: '16 / 6',
              }}
            />

            {/* Product Info */}
            <div className="p-6">
              {/* Product Name */}
              <h2 className="text-2xl font-bold text-gray-800 mb-3 text-center">
                {product.name}
              </h2>

              {/* Product Description */}
              <p className="text-gray-600 text-center mb-6">
                {product.description}
              </p>

              {/* Product Price */}
              <p className="text-xl font-bold text-lg text-center mb-6">
              Total (Inc VAT): £{product.price}
              </p>

              {/* Add to Cart Button */}
              <div className="flex justify-center">
              <button
                className="flex items-center text-white px-4 py-2 rounded-full gap-3"
                style={{ backgroundColor: '#EC008C' }}
                onClick={handleAddToCart} // Attach the function here
              >
                Add to Cart
              </button>

              </div>

              {isPopupVisible && (
  <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg text-center">
      <h2 className="text-xl font-bold mb-4">Success!</h2>
      <p>The sample has been added to the cart successfully.</p>
      <button
        className="mt-4 bg-pink-500 hover:bg-pink-600 text-white py-2 px-4 rounded-lg"
        onClick={() => {
          setIsPopupVisible(false); // Hide the popup
          window.location.href = '/Cart'; // Redirect to the homepage
        }}
      >
        Done
      </button>
    </div>
  </div>
)}

            </div>
          </div>
        ) : (
          <p className="text-red-500">Product not found.</p>
        )}
      </div>

      {isModalVisible && (
  <LoginModal
    isModalVisible={isModalVisible}
    setIsModalVisible={setIsModalVisible}
    onLoginSuccess={handleLoginSuccess} // Reload the page after login success
  />
)}


      <Subscribe />
      <FixedImageMessage />
      <Footer />
    </>
  );
};

export default SampleProducts;
